import styled from 'styled-components';

import { ProductGridArea } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/constants';
import { GRID_AREA_HEADER } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/ProductHeaderPaneOld/layout';
import { media } from '~/src/styles-constants';

import { ImageSliderContainer, NavigationContainer } from '../layout';
import { Grid } from '../ProductScreen/layout';

export const SkeletonGridContent = styled(Grid)`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
  max-width: 1200px;

  grid-template-areas:
    '${ProductGridArea.Gallery}'
    '${ProductGridArea.Header}'
    '${ProductGridArea.Details}';

  ${media.M`
  margin: auto;
    grid-gap: 32px;
    grid-template-columns: 1fr 450px;

    grid-template-areas: 
    "${ProductGridArea.Breadcrumbs} ${ProductGridArea.Header}"
    "${ProductGridArea.Gallery} ${ProductGridArea.Header}"
    "${ProductGridArea.Details} ${ProductGridArea.Details}";
  `}
`;

export const SkeletonBreadCrumbs = styled(NavigationContainer)`
  background: ${({ theme }) => theme.palette.common.PLACEHOLDER};

  height: 10px;
  margin-top: 18px;
  width: 60%;
  grid-area: ${ProductGridArea.Breadcrumbs};
`;

export const SkeletonImage = styled(ImageSliderContainer)`
  background: ${({ theme }) => theme.palette.common.PLACEHOLDER};

  margin-top: 5px;
  grid-area: ${ProductGridArea.Gallery};
  flex: 0 0 100%;
  padding-bottom: 100%;
`;

export const SkeletonProductDescription = styled.div`
  grid-area: ${GRID_AREA_HEADER};

  display: flex;
  flex-direction: column;
  margin-top: 38px;
`;

export const TextLineBig = styled.div`
  background: ${({ theme }) => theme.palette.common.PLACEHOLDER};

  height: 30px;
  width: 55%;
`;

export const TextLineMedium = styled.div`
  background: ${({ theme }) => theme.palette.common.PLACEHOLDER};

  height: 20px;
  width: 25%;
  margin-top: 20px;
`;

export const TextLineSmall = styled.div`
  background: ${({ theme }) => theme.palette.common.PLACEHOLDER};

  height: 15px;
  width: 30%;
  margin-top: 35px;
`;

export const SkeletonAddToCart = styled.div`
  background: ${({ theme }) => theme.palette.common.PLACEHOLDER};
  width: 100%;
  border-radius: 10px;
  height: 75px;
  margin-top: 40px;
`;

export const SkeletonProductInfos = styled.div`
  grid-area: ${ProductGridArea.Details};

  display: flex;
  flex-direction: column;
  margin-top: 38px;
  margin-bottom: 38px;
`;
